import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  hasMore: false,
  subTopicsList: [],
  subTopicMeta: {},
  subTopicsHasMore: false,
  currentSubTopicTopicId: null,
  singleTopic: null,
  singleSubTopic: null
};

const flashCardTopics = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ALL_FLASH_CARD_TOPICS_RESPONSE: {
      const isNewSearch = action.payload.page === 1;
      return {
        ...state,
        list: isNewSearch
          ? action.payload.list
          : [...state.list, ...action.payload.list],
        meta: action.payload.meta,
        hasMore: action.payload.hasMore
      };
    }

    case types.GET_SINGLE_FLASH_CARD_TOPIC_RESPONSE:
      return {
        ...state,
        singleTopic: action.payload
      };

    case types.EDIT_FLASH_CARD_TOPIC_RESPONSE:
      return {
        ...state,
        list: state.list.map((topic) =>
          topic.id === action.payload.id ? action.payload : topic
        )
      };

    case types.DELETE_FLASH_CARD_TOPIC_RESPONSE:
      return {
        ...state,
        list: state.list.filter(
          (topic) => topic.id !== action.payload
        )
      };
    // sub-topics
    case types.GET_ALL_FLASH_CARD_SUB_TOPICS_RESPONSE: {
      const isNewSearch = action.payload.page === 1;
      return {
        ...state,
        currentSubTopicTopicId: action.payload.topicId || null,
        subTopicsList: isNewSearch
          ? action.payload.subTopicsList
          : [...state.subTopicsList, ...action.payload.subTopicsList],
        subTopicMeta: action.payload.meta,
        subTopicsHasMore: action.payload.hasMore
      };
    }
    case types.GET_SINGLE_FLASH_CARD_SUB_TOPIC_RESPONSE:
      return {
        ...state,
        singleSubTopic: action.payload
      };

    case types.EDIT_FLASH_CARD_SUB_TOPIC_RESPONSE:
      return {
        ...state,
        subTopicsList: state.subTopicsList.map((subTopic) =>
          subTopic.id === action.payload.id
            ? action.payload
            : subTopic
        )
      };

    case types.DELETE_FLASH_CARD_SUB_TOPIC_RESPONSE:
      return {
        ...state,
        subTopicsList: state.subTopicsList.filter(
          (subTopic) => subTopic.id !== action.payload
        )
      };
    default:
      return state;
  }
};

export default flashCardTopics;
